import React from 'react';

function Skills() {
    const skillGroups = [
        {
            name: "Backend Tools",
            skills: [
                { name: "Python / Django", percent: "95%" },
                { name: "Django REST Framework", percent: "95%" },
                { name: "Celery / Redis", percent: "90%" }
            ]
        },
        {
            name: "Frontend & Design",
            skills: [
                { name: "React.js", percent: "85%" },
                { name: "JavaScript / HTML / CSS", percent: "90%" },
                { name: "Bootstrap", percent: "95%" }
            ]
        },
        {
            name: "DevOps & DB",
            skills: [
                { name: "AWS (EC2/RDS/S3)", percent: "80%" },
                { name: "PostgreSQL / MySQL", percent: "90%" },
                { name: "Docker / Nginx", percent: "75%" }
            ]
        }
    ];

    return (
        <div className="rn-skill-area rn-section-gap section-separator" id="skills">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <span className="subtitle">Features</span>
                            <h2 className="title">Professional Skills</h2>
                        </div>
                    </div>
                </div>
                <div className="row mt--40">
                    {skillGroups.map((group, groupIndex) => (
                        <div key={groupIndex} className="col-lg-4 col-md-6 col-12">
                            <div className="progress-wrapper">
                                <div className="content">
                                    <span className="subtitle">{group.name}</span>
                                    <h4 className="maintitle">Expertise</h4>
                                    {group.skills.map((skill, index) => (
                                        <div key={index} className="progress-charts">
                                            <h6 className="heading">{skill.name}</h6>
                                            <div className="progress">
                                                <div
                                                    className="progress-bar wow fadeInLeft"
                                                    data-wow-duration="0.5s"
                                                    data-wow-delay=".3s"
                                                    role="progressbar"
                                                    style={{ width: skill.percent }}
                                                    aria-valuenow={parseInt(skill.percent)}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                >
                                                    <span className="percent-label">{skill.percent}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Skills;
